var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { makeItemPathKey } from '@augloop/session-cache';
import { SchemaObject } from '@augloop/types-core';
/**
 * A partial implementation of WorkflowModelItem needed for ScopeItem.id support. Functionalities not relevant to ScopeItem.id are not implemented.
 * TODO #5326116: This should be just removed once the workflow model from AL server code is adapted to work in browser.
 */
var WorkflowModelItem = /** @class */ (function () {
    function WorkflowModelItem(item) {
        this.item = item;
        this.operation = item.op;
        this.delta = item.delta;
        this.deltas = item.deltas;
        this.id = makeItemPathKey(this.itemPath);
    }
    Object.defineProperty(WorkflowModelItem.prototype, "itemPath", {
        get: function () {
            return __spreadArray(__spreadArray([], __read(this.item.parentPath), false), [this.item.id], false);
        },
        enumerable: false,
        configurable: true
    });
    WorkflowModelItem.prototype.getBody = function () {
        return this.item.body;
    };
    WorkflowModelItem.prototype.getItemReference = function () {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getParentItem = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getParentItemBody = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getPrevItem = function (_filter, _parentFilter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getPrevItemBody = function (_filter, _parentFilter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getNextItem = function (_filter, _parentFilter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getNextItemBody = function (_filter, _parentFilter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getChildItem = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getChildItemBody = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getChildItems = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getChildItemBodies = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getSubtreeItem = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getSubtreeItemBody = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getSubtreeItems = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getSubtreeItemBodies = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getContextItem = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getContextItemBody = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getContextItems = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.getContextItemBodies = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.addAnnotation = function (_body, _options) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.updateAnnotation = function (_body, _options) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.deleteAnnotation = function (_options) {
        throw new Error('Method not implemented.');
    };
    WorkflowModelItem.prototype.loadSubtree = function (_filter) {
        throw new Error('Method not implemented.');
    };
    return WorkflowModelItem;
}());
/**
 * HACK, HACK, HACK!
 * A partial implementation of workflow model for needs of personalization context and ScopeItem.id support. Functionalities not relevant to contexts and ScopeItem.id are not implemented.
 * TODO #5326116: This should be just removed once the workflow model from AL server code is adapted to work in browser.
 */
var WorkflowModel = /** @class */ (function () {
    function WorkflowModel(scopeItem, otherItems) {
        if (otherItems === void 0) { otherItems = []; }
        this.scopeItem = undefined;
        this.rootItem = undefined;
        this.normalizeFilter = function (filter) {
            if (!filter) {
                return function (item) {
                    return item !== undefined;
                };
            }
            if (typeof filter === 'function') {
                throw new Error('Not implemented yet');
            }
            if ((filter.id ? 1 : 0) + (filter.ids ? 1 : 0) + (filter.itemType ? 1 : 0) + (filter.itemTypes ? 1 : 0) !== 1) {
                throw new Error('Exactly one condition expected on IItemFilter');
            }
            if (filter.itemType) {
                return function (item) {
                    return item && SchemaObject.matchesTypesFor(item.body, [filter.itemType]);
                };
            }
            else if (filter.itemTypes) {
                return function (item) {
                    return item && SchemaObject.matchesTypesFor(item.body, filter.itemTypes);
                };
            }
            else {
                throw new Error('Not implemented yet');
            }
        };
        this.items = __spreadArray(__spreadArray([], __read(otherItems), false), [scopeItem], false);
        this.scopeItem = new WorkflowModelItem(scopeItem);
    }
    WorkflowModel.prototype.getItem = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModel.prototype.getItems = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModel.prototype.getItemBody = function (filter) {
        var items = this.getItemBodies(filter);
        return items[0];
    };
    WorkflowModel.prototype.getItemBodies = function (filter) {
        var normalizedFilter = this.normalizeFilter(filter);
        return this.items.filter(normalizedFilter).map(function (item) { return item.body; });
    };
    WorkflowModel.prototype.getItemByReference = function (_reference) {
        throw new Error('Method not implemented.');
    };
    WorkflowModel.prototype.getItemBodyByReference = function (_reference) {
        throw new Error('Method not implemented.');
    };
    return WorkflowModel;
}());
export { WorkflowModel };
//# sourceMappingURL=workflow-model.js.map